import type {
  AlertaHistorico,
  DetalheAgente,
  PainelAlertas,
  RegraAlerta,
  RegraAlertaForm,
  MensagemChat,
  PainelAgentes,
  PainelSetor,
  SetorMonitorado,
} from '@mymaxx/shared';
import { api } from './api';

const base = '/v1/supervisao';

export const supervisaoApi = {
  setores: () => api.get<SetorMonitorado[]>(`${base}/setores`),
  painel: (setorId: string) => api.get<PainelSetor>(`${base}/setores/${setorId}`),

  agentes: () => api.get<PainelAgentes>(`${base}/agentes`),

  // Alertas: as regras são de quem está logado, então nenhuma destas chamadas leva o dono.
  alertas: () => api.get<PainelAlertas>(`${base}/alertas`),
  regrasDeAlerta: () => api.get<RegraAlerta[]>(`${base}/alertas/regras`),
  salvarRegraDeAlerta: (dados: RegraAlertaForm) =>
    api.put<RegraAlerta>(`${base}/alertas/regras`, dados),
  removerRegraDeAlerta: (id: string) => api.delete<void>(`${base}/alertas/regras/${id}`),
  silenciarAlerta: (id: string, minutos: number) =>
    api.post<void>(`${base}/alertas/${id}/silenciar`, { minutos }),
  historicoDeAlertas: (setorId?: string) =>
    api.get<AlertaHistorico[]>(`${base}/alertas/historico${setorId ? `?setorId=${setorId}` : ''}`),
  detalheAgente: (usuarioId: string) => api.get<DetalheAgente>(`${base}/agentes/${usuarioId}`),
  conversa: (conversaId: string) =>
    api.get<MensagemChat[]>(`${base}/conversas/${conversaId}/mensagens`),

  redistribuir: (setorId: string) =>
    api.post<{ entregues: number }>(`${base}/setores/${setorId}/redistribuir`),

  prioridade: (conversaId: string, prioritaria: boolean) =>
    api.post<{ ok: true }>(`${base}/conversas/${conversaId}/prioridade`, { prioritaria }),
  devolver: (conversaId: string, motivo?: string) =>
    api.post<{ ok: true }>(`${base}/conversas/${conversaId}/devolver`, { motivo: motivo ?? '' }),

  transferirPara: (conversaId: string, atendenteId: string, motivo?: string) =>
    api.post<{ ok: true }>(`${base}/conversas/${conversaId}/transferir`, {
      atendenteId,
      motivo: motivo ?? '',
    }),
  desconectar: (usuarioId: string) => api.post<void>(`${base}/usuarios/${usuarioId}/desconectar`),

  limite: (usuarioId: string, limite: number) =>
    api.post<{ ok: true }>(`${base}/usuarios/${usuarioId}/limite`, { limite }),
  presenca: (usuarioId: string, status: 'online' | 'pausa' | 'offline') =>
    api.post<{ ok: true }>(`${base}/usuarios/${usuarioId}/presenca`, { status }),
};

/** O canal paralelo vive no controller de atendimento: atendente e supervisor usam o mesmo. */
export const sussurroApi = {
  historico: (conversaId: string) =>
    api.get<MensagemChat[]>(`/v1/atendimento/${conversaId}/sussurros`),
  enviar: (conversaId: string, texto: string) =>
    api.post<MensagemChat>(`/v1/atendimento/${conversaId}/sussurros`, { texto }),
};
